import { SiteRFPPhaseAPIResponse } from '@black-bear-energy/black-bear-energy-common'

type SiteRFPPhaseValues = `${SiteRFPPhaseAPIResponse}`
export type SiteRFPPhaseOption = Exclude<
  SiteRFPPhaseValues,
  'deriskingAndPermits'
>
export type ChipScale = 'small' | 'medium'

export function getSiteRFPPhaseLabel(
  phase: SiteRFPPhaseOption,
  scale: ChipScale = 'medium'
): string {
  switch (phase) {
    case 'complete':
      return 'Complete'
    case 'construction':
      return 'Construction'
    case 'preCon':
      return scale === 'medium' ? 'Pre-Construction' : 'Pre-Con'
    case 'ntp':
      return 'NTP'
    case 'permits':
      return 'Permitting'
    case 'derisking':
      return scale === 'medium' ? 'Development Derisking' : 'Derisking'
    case 'contracts':
      return 'Contracting'
    case 'rfp':
      return 'RFP'
    case 'preRFP':
      return 'Pre-RFP'
  }
}
